import { FormHelperText } from "../FormHelperText"
import { FormLabel } from "../FormLabel"

interface Props {
  label: string
  helperText?: string
  className?: string
}

export function SubHeader({ label, helperText }: Props) {
  return (
    <div className="flex flex-col">
      <hr className="mb-10" />
      <FormLabel htmlFor={label}>{label}</FormLabel>
      <FormHelperText htmlFor={label} className="mr-auto">
        {helperText}
      </FormHelperText>
    </div>
  )
}
